/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWClaimLog } from './OWClaimLog';
import {
    OWClaimLogFromJSON,
    OWClaimLogFromJSONTyped,
    OWClaimLogToJSON,
    OWClaimLogToJSONTyped,
} from './OWClaimLog';

/**
 * Collection contains the user's reward stats/progress.
 * @export
 * @interface GuildQuestUserStat
 */
export interface GuildQuestUserStat {
    /**
     * The ID of the user for which this reward is applicable.
     * @type {string}
     * @memberof GuildQuestUserStat
     */
    userId: string;
    /**
     * Reference to the OWGames document if it exists.
     * @type {string}
     * @memberof GuildQuestUserStat
     */
    game?: string;
    /**
     * Whether the quest has been completed.
     * @type {boolean}
     * @memberof GuildQuestUserStat
     */
    isCompleted: boolean;
    /**
     * Whether the reward has been claimed.
     * @type {boolean}
     * @memberof GuildQuestUserStat
     */
    isClaimed: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuildQuestUserStat
     */
    quest: string;
    /**
     * The progress towards the target.
     * @type {number}
     * @memberof GuildQuestUserStat
     */
    progress: number;
    /**
     * The target to reach to claim the reward.
     * @type {number}
     * @memberof GuildQuestUserStat
     */
    target: number;
    /**
     * The UNIX timestamp of the start of the week (Mon 12AM EST)
     * @type {number}
     * @memberof GuildQuestUserStat
     */
    weekStart?: number;
    /**
     * The progress towards the target for the current week.
     * @type {number}
     * @memberof GuildQuestUserStat
     */
    weeklyProgress?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GuildQuestUserStat
     */
    isWeeklyLimitFeedbackDismissed?: boolean;
    /**
     * 
     * @type {Array<OWClaimLog>}
     * @memberof GuildQuestUserStat
     */
    claimLogs: Array<OWClaimLog>;
    /**
     * 
     * @type {string}
     * @memberof GuildQuestUserStat
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GuildQuestUserStat
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof GuildQuestUserStat
     */
    updatedAt: number;
}

/**
 * Check if a given object implements the GuildQuestUserStat interface.
 */
export function instanceOfGuildQuestUserStat(value: object): value is GuildQuestUserStat {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('isCompleted' in value) || value['isCompleted'] === undefined) return false;
    if (!('isClaimed' in value) || value['isClaimed'] === undefined) return false;
    if (!('quest' in value) || value['quest'] === undefined) return false;
    if (!('progress' in value) || value['progress'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('claimLogs' in value) || value['claimLogs'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GuildQuestUserStatFromJSON(json: any): GuildQuestUserStat {
    return GuildQuestUserStatFromJSONTyped(json, false);
}

export function GuildQuestUserStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuildQuestUserStat {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'game': json['game'] == null ? undefined : json['game'],
        'isCompleted': json['isCompleted'],
        'isClaimed': json['isClaimed'],
        'quest': json['quest'],
        'progress': json['progress'],
        'target': json['target'],
        'weekStart': json['weekStart'] == null ? undefined : json['weekStart'],
        'weeklyProgress': json['weeklyProgress'] == null ? undefined : json['weeklyProgress'],
        'isWeeklyLimitFeedbackDismissed': json['isWeeklyLimitFeedbackDismissed'] == null ? undefined : json['isWeeklyLimitFeedbackDismissed'],
        'claimLogs': ((json['claimLogs'] as Array<any>).map(OWClaimLogFromJSON)),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function GuildQuestUserStatToJSON(json: any): GuildQuestUserStat {
    return GuildQuestUserStatToJSONTyped(json, false);
}

export function GuildQuestUserStatToJSONTyped(value?: GuildQuestUserStat | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'game': value['game'],
        'isCompleted': value['isCompleted'],
        'isClaimed': value['isClaimed'],
        'quest': value['quest'],
        'progress': value['progress'],
        'target': value['target'],
        'weekStart': value['weekStart'],
        'weeklyProgress': value['weeklyProgress'],
        'isWeeklyLimitFeedbackDismissed': value['isWeeklyLimitFeedbackDismissed'],
        'claimLogs': ((value['claimLogs'] as Array<any>).map(OWClaimLogToJSON)),
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

